import { useState, useEffect, useCallback } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useAdminSearch() {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchAdminSearch = useCallback(async () => {
    setLoading(true);
    const { response, data } = await API.admin.fetchSearch(token);

    if (response.ok) {
      setResult(data);
      setLoading(false);
    } else {
      console.error(data);
    }
  }, [token]);

  useEffect(() => {
    fetchAdminSearch()
  }, [fetchAdminSearch]);

  return {
    loading,
    refresh: fetchAdminSearch,
    ...result,
  };
}
